export const DIGIT = "9";
export const ALPHA = "A";
export const ALPHANUM = "S";
